import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { NumberText } from '../NumberText/NumberText';

import './MoneyText.css';

interface Props {
    num?: number;
    fractionalPartLength?: number;
    currency?: string;
    cls?: string;
}

export class MoneyText extends React.PureComponent<Props> {
    render() {
        const { num, fractionalPartLength = 2, currency, cls } = this.props;

        return (
            <span className={classNames(Bem.cls('money-text'), cls)}>
                <NumberText
                    num={num}
                    fractionalPartLength={fractionalPartLength}
                />{' '}
                <span
                    className={Bem.cls({
                        block: 'money-text',
                        elem: 'highlight'
                    })}
                >
                    {currency}
                </span>
            </span>
        );
    }
}
